/*
  handle purging the offline storage on app version upgrade
*/
export const CURRENT_MIGRATION_VERSION = 20251218;
export const MIGRATION_VERSION_KEY = '_persistedMigrationVersion';
